/* eslint-disable no-undef */
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { ApolloProvider } from '@apollo/client';
import App from './App';
import client from './Apollo/config';
import './styles/core.scss';

ReactDOM.render(
    <ApolloProvider client={client}>
        {/* <React.StrictMode> */}
        <BrowserRouter>
            <App />
        </BrowserRouter>
        {/* </React.StrictMode> */}
    </ApolloProvider>,
    document.getElementById('root'),
);
